import { createSlice } from '@reduxjs/toolkit';
import {
  MergedPackageModel,
  MyOrderListModel,
  Subscription,
  UserPackageModel
} from '../views/Marketplace/Maeketplace.types';
import {
  addHub,
  getBigWhale,
  getTravelPackages,
  getMarketplace,
  getTradingHubs,
  purchasePackage,
  getFlipmeCards,
  getFinUp,
  getPowerPacksHubs,
  getAkashaHubs,
  getTravelutionSubscriptions,
  autoStakeSuperNode,
  getDepositAkashaInfo,
  depositAkasha
} from '../views/Marketplace/Marketplace.actions';

export interface MarketplaceSliceType {
  loading: boolean;
  addHubLoading: boolean;
  autoStakeLoading: boolean;
  currencyType: number;
  hubs: MergedPackageModel[];
  subscriptions: MergedPackageModel[];
  userPackage: any;
  subscription: Subscription | null;
  walletSummary: any;
  exchangeRates: any;
}

const initialState = {
  loading: false,
  addHubLoading: false,
  autoStakeLoading: false,
  currencyType: 0,
  hubs: [],
  subscriptions: [],
  userPackage: null,
  subscription: null,
  walletSummary: null,
  exchangeRates: null
} as MarketplaceSliceType;

const marketplaceSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getMarketplace.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(getMarketplace.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getMarketplace.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    builder.addCase(getTradingHubs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTradingHubs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTradingHubs.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getTravelutionSubscriptions.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(
      getTravelutionSubscriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.subscriptions = payload.hubs;
        //state.userPackages = payload.userPackages;
      }
    );
    builder.addCase(getTravelutionSubscriptions.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    // BIG WHALE
    builder.addCase(getBigWhale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBigWhale.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getBigWhale.rejected, (state) => {
      state.loading = false;
    });

    // TRAVEL PACKAGES
    builder.addCase(getTravelPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTravelPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTravelPackages.rejected, (state) => {
      state.loading = false;
    });

    // FINUP

    builder.addCase(getFinUp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFinUp.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getFinUp.rejected, (state) => {
      state.loading = false;
    });

    // FLIPME CARDS
    builder.addCase(getFlipmeCards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFlipmeCards.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getFlipmeCards.rejected, (state) => {
      state.loading = false;
    });

    // POWER PACKS HUBS
    builder.addCase(getPowerPacksHubs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPowerPacksHubs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getPowerPacksHubs.rejected, (state) => {
      state.loading = false;
    });

    // AKASHA HUBS
    builder.addCase(getAkashaHubs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAkashaHubs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getAkashaHubs.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addHub.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(addHub.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      if (payload) {
        state.userPackage = payload.userPackage;
        state.currencyType = payload.currencyType;
      }
    });

    builder.addCase(purchasePackage.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchasePackage.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      if (payload) {
        state.userPackage = payload;
      }
      if (payload?.subscription) {
        state.subscription = payload.subscription;
      }
    });

    builder.addCase(addHub.rejected, (state) => {
      state.addHubLoading = false;
    });

    //akasha deposit

    builder.addCase(depositAkasha.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(depositAkasha.fulfilled, (state, { payload }) => {
      state.loading = false;
    });

    builder.addCase(depositAkasha.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getDepositAkashaInfo.pending, (state) => {
      state.loading = true;
      state.userPackage = null;
    });

    builder.addCase(getDepositAkashaInfo.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.userPackage = payload.userPackage;
      }
    });

    builder.addCase(getDepositAkashaInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(autoStakeSuperNode.pending, (state) => {
      state.autoStakeLoading = true;
    });

    builder.addCase(autoStakeSuperNode.fulfilled, (state, { payload }) => {
      state.autoStakeLoading = false;
    });

    builder.addCase(autoStakeSuperNode.rejected, (state) => {
      state.autoStakeLoading = false;
    });
  }
});

// export const { clearHubs } = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
